var map = {
	"./95508.png": "cCqO",
	"./95528.png": "y3EJ",
	"./95533.png": "nMLM",
	"./95555.png": "E/mW",
	"./95558.png": "Uzqo",
	"./95559.png": "VRvi",
	"./95561.png": "9fb/",
	"./95566.png": "hM8T",
	"./95568.png": "U/4p",
	"./95577.png": "xpB/",
	"./95580.png": "kydk",
	"./95588.png": "3pyo",
	"./95594.png": "H6h9",
	"./95595.png": "AIjd",
	"./95599.png": "TZCX",
	"./bank.png": "/OmV",
	"./上海农村商业银行.png": "xu0s",
	"./上海浦东发展银行.png": "6sxk",
	"./中信银行.png": "+xUO",
	"./中国人民银行.png": "+k9T",
	"./中国光大银行.png": "kPhD",
	"./中国农业银行.png": "Cf0C",
	"./中国工商银行.png": "GX/u",
	"./中国建设银行.png": "OlKE",
	"./中国邮政储蓄银行.png": "n0If",
	"./中国银行.png": "acLn",
	"./交通银行.png": "u2F3",
	"./兴业银行.png": "1N4J",
	"./北京农村商业银行.png": "/Q49",
	"./北京银行.png": "+pv7",
	"./华夏银行.png": "ouSt",
	"./南京银行.png": "1tJa",
	"./厦门国际银行.png": "3XIF",
	"./哈尔滨银行.png": "DqSo",
	"./宁波银行.png": "Ti4m",
	"./平安银行.png": "G4f3",
	"./广发银行.png": "oetJ",
	"./广州银行.png": "CWyc",
	"./恒生银行.png": "o1Q9",
	"./招商银行.png": "1WxX",
	"./无锡农村商业银行.png": "7cfg",
	"./晋商银行.png": "DaQ2",
	"./汉口银行.png": "HjOR",
	"./江苏江阴农村商业银行.png": "CUn0",
	"./江苏银行.png": "X6VQ",
	"./浙江泰隆商业银行.png": "cVLU",
	"./深圳发展银行.png": "82bL",
	"./温州银行.png": "uV1V",
	"./重庆银行.png": "RwZk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PxJh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank ^\.\/.*\.png$
// module id = PxJh
// module chunks = 18